import React, { useState, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.css";
import "tippy.js/dist/tippy.css";
import "./itemsSelect/itemDisplaySelectionModal.css";
import { useTranslation } from "react-i18next";
import ItemsModal from "./ItemsModal";

function ItemSelection(props) {
  const { t } = useTranslation(["translation"]);
  const [showItemsModal, setShowItemsModal] = useState(false);

  useEffect(() => {
    const container = document.querySelector('.selectionContainer');

    if (container) {
      container.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      }, { passive: true });
    }
  }, []);

  const handleItemSelect = (eventKey) => {
    props.handlePanel(eventKey);
  };

  return (
    <div className="d-inline menu-icon-only dropup">
      {/* Items Button - Toggles Items Modal */}
      <button
        className="btn mt-1 pb-0 m-0 btn-primary btn-sm"
        onClick={() => setShowItemsModal(!showItemsModal)}
      >
        <img
          className='addItemsButton'
          src="/icons/addItemsButton.png"
          height="30px"
          alt="Items"
          title='Items'
        />
      </button>

      {/* Items Modal */}
      <ItemsModal
        show={showItemsModal}
        onHide={() => setShowItemsModal(false)}
        onItemSelect={handleItemSelect}
        addItem={props.addItem}
        onAccessorySelect={props.handleAddAccessory}
        typeName={props.typeName}
        handleDoorsView={props.handleDoorsView}
        canvasHeight={props.canvasHeight}
        title={t("itemSelection-items", "Items")}
      />
    </div>
  );
}

export default ItemSelection;
